import styles from './selectAge.module.scss';
import { GoChevronLeft, GoPlus } from 'react-icons/go';
import { GoChevronRight } from 'react-icons/go';
import { childListResponse } from 'src/core/repo/child/types';

interface Props {
  ages: childListResponse[];
  selectedAgeId?: number;
  onSelectAge: (ageId: number) => void;
  onBack?: () => void;
  theme: 'night' | 'day';
  searchParams: URLSearchParams;
  openDialog: () => void;
}

const SelectAge = ({
  ages,
  selectedAgeId,
  onSelectAge,
  onBack,
  theme,
  openDialog,
}: Props) => {
  return (
    <div className={styles.container}>
      <div style={{ width: '100%' }}>
        <div className={styles.description_wrapper}>
          {onBack ? (
            <button onClick={onBack} className={styles.back_button}>
              <GoChevronLeft color="#9c1de8" size={22} />
              <p>Back</p>
            </button>
          ) : null}
          <h1 style={{ color: theme === 'day' ? '#000' : '#fff' }}>
            Select your Kid
          </h1>
          <p style={{ color: theme === 'day' ? '#000' : '#fff' }}>
            Select a Child to Narrate the Story
          </p>
        </div>
        <div className={styles.option_container}>
          <div className={styles.options}>
            {ages.map((item: childListResponse) => (
              <div
                key={item.ChildID}
                className={styles.option}
                onClick={() => onSelectAge(Number(item.ChildID))}>
                <div className={styles.option_info}>
                  <div className={styles.option_image}>
                    <img
                      src={`${item.PhotoURL}`}
                      width={40}
                      height={40}
                      alt={item.ChildName}
                    />
                  </div>
                  <div className={styles.child_info}>
                    <p>{item.ChildAge} years old</p>
                    <h2>{item.ChildName}</h2>
                  </div>
                </div>
                <div className={styles.option_action}>
                  <GoChevronRight
                    className={
                      selectedAgeId === item.ChildID
                        ? `${styles.chevron_right} ${styles.active}`
                        : styles.chevron_right
                    }
                    size={24}
                    color={
                      selectedAgeId === item.ChildID ? '#000000' : '#777777'
                    }
                  />
                </div>
              </div>
            ))}
          </div>
          <button onClick={openDialog} className={styles.add_button}>
            <GoPlus size={32} color="9C1DE8" />
            <p>Add</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectAge;
